<div class="credit-cards">
  <app-icon *ngFor="let icon of icons" [icon]="icon" class="card"> </app-icon>
</div>
